import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import Icon from '../Icon'
import useKeyboardShortcut from '../../hooks/useKeyboardShortcut'

const Modal = ({
  children,
  show = false,
  title = '',
  childClassName = 'px-4 pt-5 pb-4 sm:p-6',
  tryOnSubmit = () => {},
  onSubmit = () => {},
  onClose = () => {},
  onOutsideClick = () => {},
  dialogClasses = '',
  backdropClasses = '',
  dialogPanelClasses = '',
  dialogTitleClasses = '',
  closeButtonClasses = '',
  ...props
}) => {
  useKeyboardShortcut(['Esc'], tryOnClose)
  useKeyboardShortcut(['Escape'], tryOnClose)
  useKeyboardShortcut(['Enter'], tryOnSubmit)

  function tryOnSubmit() {
    if (onSubmit) {
      onSubmit()
    }
  }

  function tryOnClose() {
    if (onClose) {
      onClose()
    }
  }

  function tryOnOutsideClose() {
    if (onOutsideClick) {
      onOutsideClick()
    }
  }

  return (
    <>
      <Transition appear show={show} as={Fragment}>
        <Dialog as="div" className={classNames("relative z-50", dialogClasses)} onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className={classNames("fixed inset-0 bg-gray-200 bg-opacity-75", backdropClasses)}/>
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div 
              className="flex min-h-full items-center justify-center p-4 text-center"
              onClick={tryOnOutsideClose}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={classNames(dialogPanelClasses, "w-full max-w-md transform rounded bg-white px-4 pt-5 pb-4 sm:p-6 text-left align-middle shadow-xl transition-all")}>

                  {typeof onClose === 'function' && (
                    <div className="absolute top-0 right-0">
                      <button
                        type="button"
                        className={classNames("px-4 py-2 text-gray-400 hover:text-gray-500 focus:font-medium focus:text-gray-500", closeButtonClasses)}
                        onClick={tryOnClose}
                        tabIndex={-1}
                      >
                        <Icon icon={['fas', 'times']} />
                      </button>
                    </div>
                  )}

                  {!!title && (
                    <Dialog.Title as="h3" className={classNames("text-lg font-medium mb-2", dialogTitleClasses)}>{title}</Dialog.Title>
                  )}

                  {children}

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default Modal
